import React, { useState, useEffect } from 'react';
import { Button } from 'cantarus-react-ui';
import { FieldDataListStrings as ListStrings } from '../../../utils/config';
import ListManagerPopUp from '../../PopUp/ListManagerPopUp';
import ListEntry from '../ListEntry/ListEntry';
import ReorderableList from '../../ReorderableList/ReorderableList'

const FieldDataList = ({ children, fieldName, fieldValue, handleFieldDataTextChange, isPopUp }) => {

    // fieldValues for List field types will be an array of models
    const [listFieldValues, setListFieldValues] = useState(fieldValue instanceof Array ? fieldValue : []);
    const [entryToEdit, setEntryToEdit] = useState({});
    const [showManagerPopUp, setShowManagerPopUp] = useState(false);

    useEffect(() => {
        handleFieldDataTextChange(fieldName, listFieldValues);
    }, [listFieldValues]);

    const toggleManagerPopUp = () => {
        // clear data when popup is closing
        showManagerPopUp && setEntryToEdit({})

        setShowManagerPopUp(!showManagerPopUp)

    }

    const handleAddListEntry = (fieldValues) => {
        setListFieldValues([...listFieldValues, fieldValues]);
    }

    const handleEditListEntry = (index, updatedValues) => {
        var listEntry = listFieldValues.slice();
        listEntry.splice(index, 1, updatedValues);
        setListFieldValues(listEntry);
    }

    const handleDeleteListEntry = (index) => {
        var listEntry = listFieldValues.slice();
        listEntry.splice(index, 1);
        setListFieldValues(listEntry);
    }

    const handleEditClick = (index, listEntry) => {
        setEntryToEdit({
            index: index,
            dataModel: listEntry
        })
        toggleManagerPopUp();
    }

    const handleReorder = (neworder) => {
        const currentList = listFieldValues.slice();
        var reorderedList = [];
        neworder.forEach(index => {
            reorderedList.push(currentList[index])
        })
        setListFieldValues(reorderedList);
    }

    return (
        <div className="td-field-data-list">
            <ReorderableList onReorder={handleReorder}>
                {listFieldValues && listFieldValues.map((value, index) =>
                    <ListEntry
                        entryKey={index}
                        dataFields={children}
                        dataFieldValues={value}
                        onDeleteListEntry={() => handleDeleteListEntry(index)}
                        onEditListEntry={() => handleEditClick(index, value)}
                    />
                )}
            </ReorderableList>
            <Button classes={['small']} onClick={toggleManagerPopUp} text={ListStrings.addEntry} />
            <ListManagerPopUp
                show={showManagerPopUp}
                togglePopUp={toggleManagerPopUp}
                onAddListEntry={handleAddListEntry}
                onEditListEntry={handleEditListEntry}
                dataFields={children}
                listManagerkey={entryToEdit ? entryToEdit.index : listFieldValues.length}
                dataModel={entryToEdit ? entryToEdit.dataModel : {}}
                isLayerPopUp={isPopUp}
            />
        </div>
    );
}

export default FieldDataList;
